import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '../../../app/shared/pipes/translationPipe';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-empty-search',
  imports: [MatButtonModule, TranslatePipe, AsyncPipe],
  template: `
    <div class="empty-search-container">
      <div class="no-data-title">{{ 'noResult' | translate | async }}</div>
      <div class="no-data-subtitle">
        {{ 'adjustFilters' | translate | async }}
      </div>
      <button
        mat-flat-button
        type="button"
        (click)="clearSearch()()"
        class="clear-button"
      >
        {{ 'clearFilters' | translate | async }}
      </button>
      <div></div>
    </div>
  `,
  styles: `
  @use "spacing/spacing-variables" as *;
  @use "mixins/mixins" as *;

    :host {
      display: flex;
      flex: 1;
    }
  
    .empty-search-container{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
    .no-data-title {
      align-content: flex-end;
      color: var(--mat-sys-primary);
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      line-height: 36px;
    }

    .no-data-subtitle {
      color: var(--mat-sys-primary);
      text-align: center;
      margin-top: $spacing-lg;
      margin-bottom: $spacing-lg;

      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.5px;
    }

    .clear-button {
      background-color: var(--mat-sys-secondary-container);
      color: var(--mat-sys-on-secondary-container);
      //margin: auto;
      display: flex;
    }
  `,
})
export class EmptySearchComponent {
  clearSearch = input.required<() => void>();
}
